import React from 'react';
import { TbTicket } from 'react-icons/tb';
import { AiOutlineUser } from 'react-icons/ai';

import { AnalyticsDto } from 'legacy/events/types';
import TrackingLink from '../tracking-link/TrackingLink';
import { currencyFormat } from 'legacy/common/utils/currency';

type TrackingLinksProps = {
  trackingLinks: AnalyticsDto['trackingLinks'];
};

const TrackingLinks: React.FC<TrackingLinksProps> = ({ trackingLinks }) => (
  <div className="w-full md:w-[496px] mx-auto mt-4 p-4 pb-10">
    {trackingLinks?.length === 0 ? (
      <div className="py-10 mx-auto text-center">
        <img src="/img/events/create/tracking-links.png" className="mx-auto" />
        <div className="text-sn font-normal text-gray-500">
          Tracking links will appear here
        </div>
      </div>
    ) : (
      <h2 className="text-base font-semibold">Tracking Links</h2>
    )}

    {trackingLinks?.map((trackingLink) => (
      <div
        className="mt-6 bg-white shadow-xl rounded-2xl border-gray-100 border-1"
        key={trackingLink.id}
      >
        <div className="px-4 py-8">
          <TrackingLink trackingLink={trackingLink} />
        </div>

        <div className="flex bg-primary-200 justify-between p-6">
          <div>
            <div className="text-base flex items-center font-normal">
              <AiOutlineUser className="mr-1 text-lg font-normal" />
              Unique Viewers
            </div>
            <div className="mt-2 text-3xl font-semibold">
              {trackingLink.views || 0}
            </div>
          </div>

          <div>
            <div className="text-base flex items-center font-normal">
              <TbTicket className="mr-1 text-lg" />
              Sales
            </div>
            <div className="mt-2 text-3xl font-semibold">
              {trackingLink.sales || 0}
            </div>
          </div>

          <div>
            <div className="text-base flex items-center font-normal">
              <img src="/img/events/cash.svg" className="mr-1" />
              Revenue
            </div>
            <div className="mt-2 text-3xl font-semibold">
              {currencyFormat(trackingLink.revenue)}
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default TrackingLinks;
